import React, { useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningTriangle from '../../../components/WarningTriangle';
import Popper from '@mui/material/Popper';
import { Box } from '@mui/material';

const Row = ({ name, component, warning, hmrcWarning, toolTip, rowProps }) => {
  const tooltipRef = useRef();
  const [popperOpen, setPopperOpen] = useState(false);

  const handleMouseEnter = () => {
    setPopperOpen(true);
  };

  const handleMouseLeave = () => {
    setPopperOpen(false);
  };

  const hmrcErrors = useMemo(() => {
    if (!hmrcWarning) return null;
    if (hmrcWarning.msgs) return hmrcWarning.msgs.map((i) => ({ msg: i }));
    return Object.keys(hmrcWarning)
      .filter((k) => k !== 'modalError' && k !== 'lineError' && k !== 'id' && k !== 'msg' && k !== 'type')
      .map((k) => hmrcWarning[k])
      .reduce((p, c) => [...p, ...c.msgs.map((i) => ({ msg: i }))], []);
  }, [hmrcWarning]);

  const rowStyles = { leftColumnWidth: '30%', rightColumnWidth: '70%', ...rowProps };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 0,
      }}
    >
      <div style={{ width: rowStyles.leftColumnWidth, display: 'flex', alignItems: 'center' }}>
        <div style={{ width: 30, fontWeight: 'bold' }}>
          {warning && Object.keys(warning).length > 0 && (
            <WarningTriangle
              message={
                warning?.msg
                  ? warning.msg
                  : warning?.modalError?.msg
                    ? warning.modalError.msg
                    : warning?.lineError?.msg
                      ? warning.lineError.msg
                      : null
              }
              errors={Object.keys(warning)
                .filter((k) => k !== 'modalError' && k !== 'lineError' && k !== 'id' && k !== 'msg' && k !== 'type')
                .map((k) => warning[k])}
            />
          )}
          {hmrcWarning && (
            <WarningTriangle
              color="red"
              message={
                hmrcWarning?.msgLocal || hmrcWarning?.msg || hmrcWarning?.modalError?.msg || hmrcWarning?.lineError?.msg
              }
              errors={hmrcErrors}
            />
          )}
        </div>
        <div style={{ fontWeight: 'bold', marginLeft: 15 }}>{name}</div>
        <div style={{ width: 40, fontWeight: 'bold', marginLeft: 'auto' }}>
          {toolTip && (
            <>
              <IconButton ref={tooltipRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <InfoOutlined sx={{ color: '#00395d' }} />
              </IconButton>
              <Popper placement="top" open={popperOpen} anchorEl={tooltipRef.current} style={{ zIndex: 9999999 }}>
                <Box
                  sx={{
                    border: 1,
                    borderColor: '#004',
                    borderRadius: 1,
                    p: 1,
                    bgcolor: 'white',
                    color: '#66f',
                    boxShadow: 12,
                    fontWeight: 'bold',
                  }}
                >
                  {toolTip}
                </Box>
              </Popper>
            </>
          )}
        </div>
      </div>
      <div style={{ width: rowStyles.rightColumnWidth, backgroundColor: 'white', padding: 15 }}>{component}</div>
    </div>
  );
};

Row.propTypes = {
  name: PropTypes.string,
  component: PropTypes.element,
  warning: PropTypes.object,
  hmrcWarning: PropTypes.object,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default Row;
